import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: "Hondumotos",
  storage: window.localStorage,
  modules: [
    "titlepage",
    "user",
    "role",
    "selectBrand",
    "darkmode",
    "business",
    "selectedCorporative",
  ],
});

export default new Vuex.Store({
  state: {
    search: "",
    searchTerm: "",
    visibleSearch: true,
    business: null,
    selectBrand: null,
    selectedCorporative: "",
    titlepage: "",
    darkmode: true,
    user: {},
    role: "",
    SnackbarAlert: {
      text: "",
      timeout: 2000,
      btn_closed: false,
      icon: false,
      type: "",
    },
  },
  mutations: {
    AlertSnackbar(state, config) {
      state.SnackbarAlert = config;
      return state.SnackbarAlert;
    },
    mode(state, mode) {
      state.darkmode = mode;
      return state.darkmode;
    },
    setUser(state, target) {
      state.user = target;
      state.role = target.type;
    },
    setselectBrand(state, target) {
      state.selectBrand = target;
    
    },
  
    setBusiness(state, target) {
      state.business = target;
    },
    setAppFrame(state, target) {
      state.appFrame = target;
    },
    visibleSearch(state, target) {
      state.visibleSearch = target;
    },
    setSearch(state, target) {
      state.search = target;
    },
    setSearchTerm(state, target) {
      state.searchTerm = target;
    },
    settitlepage(state, target) {
      state.titlepage = target;
    },
    setNavBar(state, target) {
      state.navBar = target;
    },
    _searchTerm(state, target) {
      state.searchTerm = target;
    },
    setCorporative(state, target) {
      state.selectedCorporative = target;
    },
    setUserValidity(state, target) {
      state.userIsValid = target;
      setTimeout(() => {
        state.userIsValid = true;
      }, 3000);
    },
  },
  actions: {
    Alert_: ({ commit, state }, config) => {
      commit("AlertSnackbar", config);
    },
    mode: ({ commit, state }, mode) => {
      commit("mode", mode);
    },
    titlepage: ({ commit, state }, t) => {
      commit("settitlepage", t);
    },
    addCorporative: ({ commit, state }, business) => {
      commit("setCorporative", business);
    },
    addNewCover: ({ commit, state }, cover) => {
      commit("setAddNewCover", cover);
    },
    visibleSearch: ({ commit, state }, t) => {
      commit("visibleSearch", t);
    },
    addBusiness: ({ commit, state }, business) => {
      commit("setBusiness", business);
    },
    addBrand: ({ commit, state }, brands) => {
      commit("setselectBrand", brands);
    },
    setUser: ({ commit, state }, user) => {
      commit("setUser", user);
    },

    _searchTerm: ({ commit, state }, dat) => {
      commit("_searchTerm", dat);
    },
    setUserValidity_: ({ commit, state }, i) => {
      commit("setUserValidity", i);
    },
  },
  getters: {
    Alert_: (state) => {
      return state.SnackbarAlert;
    },
   
  },
  modules: {},
  plugins: [vuexPersist.plugin],
});
